<script lang="ts" setup>
import { computed } from 'vue'

import RoomieTag from '@lahaus-roomie/roomie/src/components/RoomieTag/index.vue'
import type { Props } from './types'
import AppCarrousel from '@/components/App/CarrouselV2/index.vue'

const props = withDefaults(defineProps<Props>(), {
  showUnitsLink: false
})

const { t } = useI18n()

const getPictures = computed(() => props.pictures ?? [])

const generateImageObjects = (url: string) => {
  const baseSrc = `${url}?auto=compress,enhance,format`
  return [
    { mediaWidth: 640, src: baseSrc, imageWidth: 400 },
    { mediaWidth: 1023, src: baseSrc, imageWidth: 800 },
    { mediaWidth: 2500, src: baseSrc, imageWidth: 1080 }
  ]
}

const picturesSources = computed(
  () => getPictures.value.map((url: string) => generateImageObjects(url))
)

const resolveShowPictures = computed(() => Boolean(props.pictures?.length))

</script>

<script lang="ts">
export default {
  name: 'TypologyCarrousel'
}
</script>

<template>
  <section class="typology-carrousel rounded-md relative px-16">
    <AppCarrousel
      v-if="resolveShowPictures"
      id="quotation-plan-typology-blueprints"
      class="rounded-8 h-full w-full"
      :class="'aspect-square'"
      anchor-styles="w-full"
      img-styles="rounded-8"
      :image-multiplier="2"
      :data-attributes="{...dataAttributes, dataLh: { ...dataAttributes.dataLh, A: 'seleccionar', C: t('type', { name: typologyName }) }}"
      :pictures-sources
      zoom
      size-reverse />

    <RoomieTag
      v-if="typologyName"
      :id="`typology-carrousel-${typologyName}-tag`"
      class="typology-carrousel-tag absolute top-[30px] left-[30px]"
      variant="neutral"
      size="lg"
      :label="t('type', { name: typologyName })" />
  </section>
</template>

<i18n src="./i18n.json" lang="json" />

<style lang="scss">
.lh-roomie-v2 {
  .typology-carrousel {
    border-radius: 24px;
    border: 2px solid #E3E9F1;

    .typology-carrousel-tag {
      border: 0;
      border-radius: 6px;
      background: #E3E9F1;
      color: #004132;
      font-size: 1.4rem !important;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      letter-spacing: -0.14px;
      padding: 1.2rem 2.4rem !important;
    }
  }
}
</style>
